// extracted by mini-css-extract-plugin
module.exports = {"seeLiveProject1":"Murals-module--seeLiveProject1--1ScW-","sourceCodeProject1":"Murals-module--sourceCodeProject1--brMcS"};